import React, { Component } from 'react';
import iconDown from '../../images/icons/icon_downarrow.png';
import { languages as lg } from '../../constants';
import PropTypes from 'prop-types';

class LangMenu extends Component {
  constructor(props) {
    super(props);
    this.changeLanguage = this.changeLanguage.bind(this);
  }

  changeLanguage(lang) {
    const { i18n } = this.props;
    i18n.changeLanguage(lang);
    location.reload();
  }

  render() {
    const { i18n } = this.props;
    return (
      <div className="fe-header-lang-menu d-none">
        <span className="fe-header-language">{ lg[i18n.language].str }</span>
        <img src={iconDown} alt=""/>
        <ul className="fe-header-dropdown-links ">
          <li>
            <a href="#" onClick={() => this.changeLanguage(lg.en.code)}>
              { lg.en.str }
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage(lg.ms.code)}>
              { lg.ms.str }
            </a>
          </li>
          <li>
            <a href="#" onClick={() => this.changeLanguage(lg['zh-CN'].code)}>
              { lg['zh-CN'].str }
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
    

// const { language } = i18n;
//     return (
//         <div className="fe-header-lang-menu">
//             <span className="fe-header-language">{ lg[language].str }</span>
//             <img src={iconDown} alt=""/>
//             <ul className="fe-header-dropdown-links">
//                 <li>
//                     <a href="#" onClick={() => changeLanguage(i18n, lg.en.code)}>
//                         { lg.en.str }
//                     </a>
//                 </li>
//                 <li>
//                     <a href="#" onClick={() => changeLanguage(i18n, lg.bm.code)}>
//                         { lg.bm.str }
//                     </a>
//                 </li>
//                 <li>
//                     <a href="#" onClick={() => changeLanguage(i18n, lg.cn.code)}>
//                         { lg.cn.str }
//                     </a>
//                 </li>
//             </ul>
//         </div>
//     );

LangMenu.propTypes = {
  i18n: PropTypes.object.isRequired,
};

export default LangMenu;